
import { trackAcFormSuccess } from "@/utils/analytics"

export default {
  data() {
    return {
      SEO: {
        title: "Contact",
        description: "The best way to connect with us for any inquiries",
        index: true,
        canonical: "/contact",
        options: {
          script: [
            {
              src: "https://logfurnitureandmore.activehosted.com/f/embed.php?id=80",
              body: true
            }
          ]
        }
      }
    }
  },

  mounted() {
    // GA4 key event `contact_us` — fired once the ActiveCampaign form (_form_80)
    // shows its in-place success panel. GA4 counts occurrences by name only, so
    // no parameters are sent.
    this._untrackContactForm = trackAcFormSuccess({
      container: this.$el.querySelector("._form_80"),
      event: "contact_us",
      gtag: this.$gtag,
      fbq: this.$fbq
    })
  },

  beforeDestroy() {
    if (this._untrackContactForm) this._untrackContactForm()
  }
}
